<template>
  <v-layout class="rounded rounded-md">
    <router-view />
  </v-layout>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
</style>